import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4" data-id="element-51">
      <div className="max-w-3xl mx-auto bg-gradient-to-r from-[#27AE60]/20 to-[#27AE60]/5 border border-[#27AE60]/30 rounded-3xl p-8 md:p-12 text-center backdrop-blur-sm" data-id="element-52">
        <div className="flex justify-center mb-6" data-id="element-53">
          <ShieldCheck className="w-20 h-20 text-[#27AE60]" data-id="element-54" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-55">
          GARANTÍA DE 45 DÍAS — RIESGO CERO
        </h2>
        <div className="space-y-4 text-lg text-gray-300" data-id="element-56">
          <p data-id="element-57">
            Probá InfoSkills Pro durante 45 días. Usá las skills, creá tu
            contenido, armá tus ads. Si sentís que no te sirve, me escribís y te
            devuelvo el 100% de tu dinero.
          </p>
          <p className="font-bold text-white" data-id="element-58">
            Sin preguntas. Sin letra chica. Sin vueltas.
          </p>
          <p data-id="element-59">
            Si las skills no te ayudan a crear mejor y más rápido, no quiero tu
            plata. El único riesgo es seguir haciendo todo a mano.
          </p>
        </div>
      </div>
    </section>;
}